import { useState, useCallback, useRef } from 'react';
import { Toast } from 'primereact/toast';
import {
  EmailTemplateList,
  EmailTemplateDialog,
  INVITATION_EMAIL_CATEGORY,
} from '@authifi/email-templates';
import type { EmailTemplate } from '@authifi/email-templates';

export function EmailTemplatesPage() {
  const toast = useRef<Toast>(null);
  const [showCreateDialog, setShowCreateDialog] = useState(false);
  const [editTemplateId, setEditTemplateId] = useState<number | undefined>(undefined);

  const handleTemplateSelect = useCallback((template: EmailTemplate) => {
    setEditTemplateId(template.id);
  }, []);

  const handleSaved = useCallback((template: EmailTemplate) => {
    toast.current?.show({
      severity: 'success',
      summary: 'Template Saved',
      detail: `"${template.name}" has been saved.`,
      life: 3000,
    });
  }, []);

  const handleDialogHide = useCallback(() => {
    setShowCreateDialog(false);
    setEditTemplateId(undefined);
  }, []);

  const handleSuccess = useCallback((message: string) => {
    toast.current?.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
  }, []);

  const handleError = useCallback((message: string) => {
    toast.current?.show({ severity: 'error', summary: 'Error', detail: message, life: 5000 });
  }, []);

  return (
    <div>
      <Toast ref={toast} />
      <h2 className="text-2xl font-semibold text-gray-900 mb-2">Email Templates</h2>
      <p className="text-gray-500 mb-6">
        Manage and customize the email templates used for group invitations.
      </p>

      <EmailTemplateList
        categoryLabel={INVITATION_EMAIL_CATEGORY}
        onTemplateSelect={handleTemplateSelect}
        onCreateTemplate={() => setShowCreateDialog(true)}
        onSuccess={handleSuccess}
        onError={handleError}
      />

      <EmailTemplateDialog
        visible={showCreateDialog || editTemplateId != null}
        onHide={handleDialogHide}
        templateId={editTemplateId}
        categoryLabel={INVITATION_EMAIL_CATEGORY}
        onSaved={handleSaved}
      />
    </div>
  );
}
